import styled from "styled-components";
import { IconButton } from "@evergis/ui";

export const StyledIconButton = styled(IconButton)`
  width: 0.75rem;
  height: 0.75rem;

  span[kind] {
    height: 0.75rem;

    :after {
      font-size: 0.75rem;
    }
  }
`;
